module.exports = __webpack_public_path__ + "media/photo/comminutions_banners-9958ca6e.jpg";